import { strings } from '../context/LanguageContext/strings'
import { util } from '../util'

export const storeModels = {
    getStoreFilters: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'store_id',
            display_name: strings.OPS_TOOLS_STORES_STORE_ID_LABEL,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'state',
            display_name: strings.OPS_TOOLS_STORES_STATE_LABEL,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            postUtil: function ({ list, value }) {
                const remainingList = value.length
                    ? util.searchByInput(value, this.baseFilterList)
                    : []
                const uniqueStateList = new Set([...list, ...remainingList])
                let stateCodes = util.getStateCodeFromValue(uniqueStateList)
                if (list.length) {
                    stateCodes = new Set([...stateCodes, ...this.post_value])
                }
                return [...stateCodes]
            },
            displayUtil: ({ list, value }) => {
                return value.length ? list.concat(value) : list
            },
        },
        {
            type: 'list',
            key: 'city',
            display_name: strings.OPS_TOOLS_STORES_CITY_LABEL,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            postUtil: config => util.getSuggestList(config),
            displayUtil: ({ list, value }) => {
                const postValue = list.map(city =>
                    city.toLowerCase().replace(/^\w/, c => c.toUpperCase())
                )
                if (value.length && !postValue.includes(value)) {
                    postValue.push(value)
                }
                return postValue
            },
        },
        {
            type: 'list',
            key: 'zip',
            display_name: strings.OPS_TOOLS_STORES_POSTAL_CODES_LABEL,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            postUtil: config => util.getSuggestList(config),
            displayUtil: ({ value, list }) => {
                if (value.length && !list.includes(value)) {
                    list.push(value)
                }
                return list
            },
        },
    ],
}
